import React, { useRef } from 'react';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { var_api } from '../constant';
import { useHistory } from 'react-router-dom';
import './NewSettlement.css'
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import ReactToPrint from 'react-to-print';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Row } from 'reactstrap';
import Layout from '../NewHeader/Layout';


// const ReportBillPrint = React.forwardRef(({ shopDetails, selectedDate, cashSales, totalPayout, otherTotal, totalSales,allCreditTotal }, ref) => (
//     <div ref={ref} id='reportBill' style={{backgroundColor:"rgba(63, 68, 63, 0.082)",padding:"10px", maxWidth:"310px"}}>
//       <div>
//         <h3 style={{textAlign:"center",fontWeight:"lighter",textTransform:"uppercase",color:"black",fontFamily:"fantasy",letterSpacing: "3px"}}>{localStorage.getItem('shopName')}</h3>
//         {/* Render shop details */}
//         {shopDetails ? (
//           <div style={{lineHeight: "15%",fontFamily:"cursive",marginTop:"15px"}}>
//             <p style={{textAlign:"center", fontWeight:"bolder"}}>{shopDetails.address}</p>
//             <p style={{textAlign:"center", fontWeight:"bolder"}}>{shopDetails.state}, {shopDetails.country_name}</p>
//             <p style={{textAlign:"center", fontWeight:"bolder"}}>{shopDetails.user.mobile}</p>
//           </div>
//         ) : (
//           <div>Loading...</div>
//         )}
//         <hr style={{border:"2px solid black"}}/>
//         {/* Render report summary */}
//         <p style={{textAlign:"center", fontWeight:"bolder", fontSize:"20px", fontFamily:"serif"}}>Report Summary</p>
//         <p style={{textAlign:"left", fontWeight:"bolder",fontSize:"17px"}}>Date:<b>{selectedDate}</b> <span style={{float:"right"}}>Time:<b>{new Date().toLocaleTimeString()}</b></span></p>
//         <br/>
//         <h5 style={{fontFamily:"serif",color:"black",fontWeight:"bolder"}}> Cash Sales: <span style={{float:"right"}}>{cashSales ? cashSales.toFixed(3) : 0}</span></h5>
//         <h5 style={{fontFamily:"serif",color:"black",fontWeight:"bolder"}}> Total Payout: <span style={{float:"right"}}>{totalPayout? totalPayout : 0}</span></h5>
//         <h5 style={{fontFamily:"serif",color:"black",fontWeight:"bolder"}}> Other Total: <span style={{float:"right"}}>{otherTotal ? otherTotal.toFixed(3) : 0}</span></h5>
//         <h5 style={{fontFamily:"serif",color:"black",fontWeight:"bolder"}}> All Credit Total: <span style={{float:"right",fontFamily:"monospace"}}>{allCreditTotal ? allCreditTotal.toFixed(3) : 0}</span></h5>
//         <hr style={{border:"2px solid black"}}/>
//         <h5 style={{fontFamily:"serif",color:"black",fontWeight:"bolder",fontSize:"22px"}}> Total Sales: <span style={{float:"right"}}>{totalSales ? totalSales.toFixed(3) : 0}</span></h5>
//         <h5 style={{fontFamily:"serif",color:"black",marginTop:"20px", fontSize:"22px"}}> Balance Cash:{" "} <span style={{float:"right"}}>{( cashSales - totalPayout).toFixed(3)}</span></h5>
//         <hr style={{border:"2px solid black"}}/>
//         <div style={{marginTop:"-21px",lineHeight:"10px"}}>
//           <br/>
//           <h6 style={{textAlign:"center",fontFamily:"monospace",fontWeight:"bolder",color:"black",margin:"5px", fontSize:"19px"}}>Have a Nice Day...!</h6>
//         </div>
//       </div>
//     </div>
//   ));


const NewSettlement = () => {
    const [selectedDate, setSelectedDate] = useState(getYesterdayDate());
    const [selectedDatepaymode, setSelectedDatepaymode] = useState(new Date().toISOString().split('T')[0]);
    const [normalpayment, setNormalPayment] = useState([]);
    const [creditpayment, setCreditPayment] = useState([]);
    const [expenselog, setExpenselog] = useState([]);
    const [paymode, setPaymode] = useState([]);
    const [creditPaymode, setCreditPaymode] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoading1, setIsLoading1] = useState(false); // Add isLoading state
    // const [cashSales, setCashSales] = useState(null);
    // const [otherTotal, setOtherTotal] = useState(null);
    const [totalPayout, setTotalPayout] = useState(null);
    const [totalSales, setTotalSales] = useState(null);
    const [allCreditTotal, setAllCreditTotal] = useState(null);
    const [loading, setLoading] = useState(false);
    const [shopDetails, setShopDetails] = useState(null);
    const history = useHistory();
    const valtoday = new Date().toISOString().split('T')[0];
    const componentRef = useRef(null); 
    const printingType = localStorage.getItem("printingType");
    

    useEffect(() => {
        const currentFormattedDate = formatDate(new Date());
    setSelectedDatepaymode(currentFormattedDate); // Set to DD-MM-YYYY for API
     fetchNormalPayment(currentFormattedDate);
    fetchCreditPayment(currentFormattedDate);
    fetchExpensePayment(currentFormattedDate);
    }, []); // Add selectedDate to the dependency array


 
      // Fetch tables data
  const fetchNormalPayment = async (date) => {
    setLoading(true);
    const shop_id = localStorage.getItem('ShopId');
    const token = localStorage.getItem('Token');

    try {
      const response = await axios.get(
        `${var_api}settlement/normal-order/${shop_id}/${date}`,
        {
          headers: {
            Authorization: `${token}`, // Add the token to the Authorization header dynamically
          },
        }
      );
      setLoading(false);
      console.log("Response received:", response);
      const user = response.data.data;
      setNormalPayment(user);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };


  // Fetch tables data
  const fetchCreditPayment = async (date) => {
    setLoading(true);
    const shop_id = localStorage.getItem('ShopId');
    const token = localStorage.getItem('Token');

    try {
      const response = await axios.get(
        `${var_api}settlement/credit-order/${shop_id}/${date}`,
        {
          headers: {
            Authorization: `${token}`, // Add the token to the Authorization header dynamically
          },
        }
      );
      setLoading(false);
      console.log("Response received:", response);
      const user = response.data.data;
      setCreditPayment(user);
      const totalCredit = user.reduce((acc, credit) => acc + (credit.amount || 0), 0);
      setAllCreditTotal(totalCredit)
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };



  // Fetch tables data
  const fetchExpensePayment = async (date) => {
    setLoading(true);
    const shop_id = localStorage.getItem('ShopId');
    const token = localStorage.getItem('Token');

    try {
      const response = await axios.get(
        `${var_api}expense-log/${shop_id}/${date}`,
        {
          headers: {
            Authorization: `${token}`, // Add the token to the Authorization header dynamically
          },
        }
      );
      setLoading(false);
      console.log("Response received:", response);
      const user = response.data.data;
      setExpenselog(user);
      const totalExpense = user.reduce((acc, expense) => acc + (expense.total_paid_amount || 0), 0);
      setTotalPayout(totalExpense);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };




function getYesterdayDate() {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const dd = String(yesterday.getDate()).padStart(2, '0');
    const mm = String(yesterday.getMonth() + 1).padStart(2, '0'); // January is 0!
    const yyyy = yesterday.getFullYear();

    return `${dd}-${mm}-${yyyy}`;
}


const handleDateChangepaymode = (e) => {
    const rawDate = e.target.value; // Raw date in YYYY-MM-DD
    const formattedDate = formatDate(rawDate); // Format it to DD-MM-YYYY
    setSelectedDatepaymode(formattedDate);
  
    // Call the API with the formatted date
    fetchNormalPayment(formattedDate);
    fetchCreditPayment(formattedDate);
    fetchExpensePayment(formattedDate);
  };
  
  function formatDate(dateString) {
    const date = new Date(dateString); // Convert to Date object
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // January is 0!
    const yyyy = date.getFullYear();
  
    return `${dd}-${mm}-${yyyy}`; // Return formatted date
  }

  const calculateTotals = (normalpayment, creditpayment) => {
    let cashTotal = 0;
    let otherTotal = 0;
  
    // Sum up cash sales for normal and credit payments
    normalpayment.forEach((table) => {
      if (table.paymode_name === "cash") {
        cashTotal += table.amount || 0;
      } else {
        otherTotal += table.amount || 0;
      }
    });
  
    creditpayment.forEach((table) => {
      if (table.paymode_name === "cash") {
        cashTotal += table.amount || 0;
      } else {
        otherTotal += table.amount || 0;
      }
    });
  
    return { cashTotal, otherTotal };
  };

  const { cashTotal, otherTotal } = calculateTotals(normalpayment, creditpayment);


//   const handlePrints = async () => {
//     try {
//         // Get the reference to the ReportBillPrint component
//         const component = componentRef.current;

//         if (!component) {
//             console.error('Component reference not found.');
//             return;
//         }

//         // Ensure the component is fully rendered before capturing
//         await new Promise(resolve => setTimeout(resolve, 1000)); // Adjust timeout as needed

//         // Capture the component as an image using html2canvas
//         const canvas = await html2canvas(component, {
//             scale: 2, // Adjust scale for better quality
//             useCORS: true // Ensure cross-origin images are captured properly if needed
//         });

//         // Convert the canvas to an image (PNG format by default)
//         const imgData = canvas.toDataURL('image/png');

//         // Calculate dimensions for PDF creation
//         const imgWidth = 1.98; // Width in inches
//         const imgHeight = (canvas.height / canvas.width) * imgWidth; // Maintain aspect ratio

//         // Create a new jsPDF instance for PDF generation
//         const pdf = new jsPDF({
//             orientation: 'portrait', // Set orientation (portrait or landscape)
//             unit: 'in', // Set unit of measurement
//             format: [imgWidth, imgHeight] // Set dimensions of the PDF
//         });

//         // Add the image captured from canvas to the PDF
//         pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);

//         // Convert the PDF to base64 data URI
//         const pdfData = pdf.output('datauristring');
//         const printerName = localStorage.getItem("selectedPrinter");

//         // Send the base64 PDF data to the backend for printing
//         await axios.post('http://localhost:3001/print', {
//             data: pdfData.split(',')[1] ,// Extract base64 data from the URI
//             printerName: printerName
//         });

//     } catch (err) {
//         console.error('Error printing:', err);
//     }
// };


    return(
        <>
        <Layout>
        <div  style={{backgroundColor:"white",width: "100%",marginLeft:"40px" }}  >
    
    <br/>
    {/* New design */}
    <div style={{  display: 'flex',flexDirection:"column"}}>
    <h4 className='ushens'>SETTLEMENTS</h4>
<div className="card" style={{ maxWidth: '300px'  }}>
        <div className="card-body" style={{ display: 'flex', flexDirection: 'row', alignItems: 'right'}}>
            <p className="card-text" style={{ marginRight: '10px',fontWeight:"bolder" }}>Date: </p>
            <i className="bi bi-search" style={{ marginRight: '5px'}}></i>
            <input
        type="date"
        id="yesterdayDateInput"
        className="form-control"
        style={{ marginRight: "5px", marginBottom: "15px", color: "blue" }}
        value={selectedDatepaymode
          .split("-")
          .reverse()
          .join("-")} // Convert DD-MM-YYYY to YYYY-MM-DD for input field
        onChange={handleDateChangepaymode}
        max={valtoday} // Restrict max date to today
      />
        </div>
    </div>
    </div>

        <br/>

        {/* newdesgin */}
        <div style={{ display: 'flex', justifyContent: 'space-around', gap: '20px', padding: '20px' }}>
            
    <div style={{ flex: '1' }}>
    <div style={{ width: '100%' }}>
        {isLoading ? (
            <div className="loader-container">
                <div className="loader"></div>
            </div>
        ) : (
            <>
   
        <h6 style={{ fontWeight: "bolder", textAlign: "center", color: "green" }}>Normal Order Amount Collection</h6>
        <div className="card" style={{ width: '100%', height: "auto", border: "2px solid green" }}>
            <div className="card-body">
                <div style={{ borderBottom: "2px solid black", paddingBottom: "10px", marginBottom: "10px" }}>
                    <div className="card-title" style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ flex: '1', textAlign: 'left' }}><strong>Paymode</strong></div>
                        <div style={{ flex: '1', textAlign: 'left' }}><strong>Amount</strong></div>
                    </div>
                </div>
                {normalpayment.length === 0 ? (
                    <div style={{ textAlign: 'center', marginTop: '50px' }}>No Paymode Summary</div>
                ) : (
                    normalpayment.map((table, index) => (
                        <div className="content" key={index} style={{ borderBottom: "1px solid black", paddingBottom: "5px", marginBottom: "5px", display: 'flex', justifyContent: 'space-between', alignItems: "center" }}>
                            <div style={{ flex: '1', textAlign: 'left' }}>{table.paymode_name}</div>
                            <div style={{ flex: '1', textAlign: 'left'}}>{table && table.amount ? table.amount.toFixed(3) : 0}</div>
                        </div>
                    ))
                )}
            </div>
        </div>
        </>
        )}
        </div>
    </div>

    <div style={{ flex: '1' }}>
           {/* Credit Order Balance Amount Collection Card */}
    <div style={{ width: '100%' }}>
        {isLoading ? (
            <div className="loader-container">
                <div className="loader"></div>
            </div>
        ) : (
            <>
        <h6 style={{ fontWeight: "bolder", textAlign: "center", color: "green" }}>Credit Order Balance Amount Collection</h6>
        <div className="card" style={{ width: '100%', height: "auto", border: "2px solid green" }}>
            <div className="card-body">
                <div style={{ borderBottom: "2px solid black", paddingBottom: "10px", marginBottom: "10px" }}>
                    <div className="card-title" style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ flex: '1', textAlign: 'left' }}><strong>Paymode</strong></div>
                        <div style={{ flex: '1', textAlign: 'left' }}><strong>Amount</strong></div>
                    </div>
                </div>
                {creditpayment.length === 0 ? (
                    <div style={{ textAlign: 'center', marginTop: '50px' }}>No Paymode Summary</div>
                ) : (
                    creditpayment.map((table, index) => (
                        <div className="content" key={index} style={{ borderBottom: "1px solid black", paddingBottom: "5px", marginBottom: "5px", display: 'flex', justifyContent: 'space-between', alignItems: "center" }}>
                            <div style={{ flex: '1', textAlign: 'left' }}>{table.paymode_name}</div>
                            <div style={{ flex: '1', textAlign: 'left' }}>{table && table.amount ? table.amount.toFixed(3) : 0}</div>
                        </div>
                    ))
                )}
            </div>
        </div>
        </>
        )}
    </div>
    </div>
    <div style={{ flex: '1' }}>
    <div style={{ width: '100%' }}>
        {isLoading ? (
            <div className="loader-container">
                <div className="loader"></div>
            </div>
        ) : (
            <>
   
        <h6 style={{ fontWeight: "bolder", textAlign: "center", color: "green" }}>Expense Order Amount Collection</h6>
        <div className="card" style={{ width: '100%', height: "auto", border: "2px solid green" }}>
            <div className="card-body">
                <div style={{ borderBottom: "2px solid black", paddingBottom: "10px", marginBottom: "10px" }}>
                    <div className="card-title" style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ flex: '1', textAlign: 'left' }}><strong>Paymode</strong></div>
                        <div style={{ flex: '1', textAlign: 'left' }}><strong>Amount</strong></div>
                    </div>
                </div>
                {expenselog.length === 0 ? (
                    <div style={{ textAlign: 'center', marginTop: '50px' }}>No Paymode Summary</div>
                ) : (
                    expenselog.map((table, index) => (
                        <div className="content" key={index} style={{ borderBottom: "1px solid black", paddingBottom: "5px", marginBottom: "5px", display: 'flex', justifyContent: 'space-between', alignItems: "center" }}>
                            <div style={{ flex: '1', textAlign: 'left',  }}>{table.supplier_name? table.supplier_name :"-"}</div>
                            <div style={{ flex: '1', textAlign: 'left', }}>{table && table.total_paid_amount ? table.total_paid_amount.toFixed(3) : 0}</div>
                        </div>
                    ))
                )}
            </div>
        </div>
        </>
        )}
        </div>
    </div>

    <div style={{ flex: '1'}}>
    <div style={{ width: '100%' }}>
        {isLoading ? (
            <div className="loader-container">
                <div className="loader"></div>
            </div>
        ) : (
            <>
        <h6 style={{ fontWeight: "bolder", textAlign: "center", color: "green" }}>Summary Report</h6>
        <div className="card" style={{ width: '100%', height: "auto", border: "2px solid green", margin: "auto" }}>
            <div className="card-body">
                <h5 style={{ fontFamily: "serif", color: "red", fontWeight: "normal" }}>Cash Sales: <span style={{ float: "right", fontFamily: "monospace" }}>{cashTotal ? cashTotal.toFixed(3) : 0}</span></h5>
                <h5 style={{ fontFamily: "serif", color: "black", fontWeight: "normal" }}>Total Expense: <span style={{ float: "right", fontFamily: "monospace" }}>{totalPayout ? totalPayout.toFixed(3) : 0}</span></h5>
                <h5 style={{ fontFamily: "serif", color: "red", fontWeight: "normal" }}>Other Total: <span style={{ float: "right", fontFamily: "monospace" }}>{otherTotal ? otherTotal.toFixed(3) : 0}</span></h5>
                <h5 style={{ fontFamily: "serif", color: "blue", fontWeight: "normal" }}>All Credit Total: <span style={{ float: "right", fontFamily: "monospace" }}>{allCreditTotal ? allCreditTotal.toFixed(3) : 0}</span></h5>
                <hr />
                <h5 style={{ fontFamily: "serif", color: "red", fontWeight: "bolder" }}>Total Sales: <span style={{ float: "right", fontFamily: "monospace" }}>{(cashTotal+otherTotal) ? (cashTotal+otherTotal).toFixed(3) : 0}</span></h5>
                <h5 style={{ fontFamily: "serif", color: "green", marginTop: "20px" }}>Balance Cash: <span style={{ float: "right", fontFamily: "monospace" }}>{((cashTotal+otherTotal) - totalPayout).toFixed(3)}</span></h5>
            </div>
        </div>
        </>
        )}
    </div>
       
  
    </div>
</div>
{/* 
        <Modal
        show={isOpen}
        onHide={()=>setIsOpen(false)}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
      >
        <Modal.Header closeButton >
          <Modal.Title>confirmation</Modal.Title> Print Report Summary
        </Modal.Header>
        <Modal.Body>

        <ReportBillPrint
          ref={componentRef}
          shopDetails={shopDetails}
          selectedDate={selectedDate}
          cashSales={cashSales}
          totalPayout={totalPayout}
          otherTotal={otherTotal}
          totalSales={totalSales}
          allCreditTotal = {allCreditTotal}
        />

          <Button variant="danger" style={{float:"right"}} onClick={()=>setIsOpen(false)}>
            Close
          </Button>{' '} 

          {
            printingType == "directPrint" ?  (
                <button className='btn btn-success'  style={{ borderRadius: '5px', border: 'none', margin: '5px',float:"right" }} onClick={handlePrints}><i className='bi bi-printer-fill'></i> Print Directly</button>
            ) : (
          
          <ReactToPrint
          trigger={() => (
            <Button variant="primary" style={{float:"right",marginRight:"5px"}}>
              <i className="bi bi-printer-fill"></i> Print via Google
            </Button>
          )}
          content={() => componentRef.current}
        />
            )}
         
        </Modal.Body>
       
      </Modal> */}
        </div>
        </Layout></>
  

        
    )
}

export default NewSettlement;